import { render } from "./TaskEditStatus.vue?vue&type=template&id=656ef7ce&scoped=true"
import script from "./TaskEditStatus.vue?vue&type=script&lang=js"
export * from "./TaskEditStatus.vue?vue&type=script&lang=js"

import "./TaskEditStatus.vue?vue&type=style&index=0&id=656ef7ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656ef7ce"]])

export default __exports__